import { z } from 'zod';

export const TalonOneCampaignSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string(),
  startDateTime: z.union([z.date(), z.string()]).nullish(),
  endDateTime: z.union([z.date(), z.string()]).nullish(),
  status: z.string(),
  campaignType: z.string().nullish(),
});
export type TalonOneCampaign = z.infer<typeof TalonOneCampaignSchema>;

export const TalonOnePromoSchema = z.object({
  id: z.number().nullish(),
  code: z.string(),
  expiryDateTime: z.string(),
  externalLink: z.string(),
  campaign: TalonOneCampaignSchema,
  status: z.string(),
  couponDiscountLimit: z.number().nullish(),
  couponCurrency: z.string().nullish(),
});
export type TalonOnePromo = z.infer<typeof TalonOnePromoSchema>;

export const TalonOnePromoStateSchema = TalonOnePromoSchema.extend({
  clientId: z.string(),
});
export type TalonOnePromoState = z.infer<typeof TalonOnePromoStateSchema>;

export const TalonOnePromoResponseSchema = z.object({
  data: TalonOnePromoSchema.array(),
  totalItems: z.number(),
  pageSize: z.number(),
  pageNumber: z.number(),
  couponsFinder: z.string(),
});
export type TalonOnePromoResponse = z.infer<typeof TalonOnePromoResponseSchema>;
